var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.modify_withdraw_type"),
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("system.withdraw_details")) + " "),
          ]),
          _vm.withdraw_fee_status === 1
            ? _c("div", { staticClass: "section-tip" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("system.handling_fee")) +
                    ": " +
                    _vm._s(_vm._f("toDivideWithDot")(_vm.withdraw_fee)) +
                    " " +
                    _vm._s(_vm.$t("system.per_transaction")) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.posWithdrawConfigLocked
            ? _c("div", { staticClass: "pos-withdraw-lock-tip" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("system.pos_withdraw_config_locked")) +
                    " "
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "modify-password" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "200px",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.withdraw_type"),
                                required: "",
                                prop: "withdraw_type",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "input-password",
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.posWithdrawConfigLocked,
                                  },
                                  model: {
                                    value: _vm.form.withdraw_type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "withdraw_type", $$v)
                                    },
                                    expression: "form.withdraw_type",
                                  },
                                },
                                _vm._l(
                                  _vm.withdrawTypeMap,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.withdraw_type === 2
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "merchant.withdrawal_account"
                                    ),
                                    required: "",
                                    prop: "bank_no",
                                  },
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("merchant.withdrawal_account")
                                        ) + " "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            color: "#7A869E",
                                            "line-height": "1.5",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "tips.cash_out_support_local_bank"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input-password",
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.form.bank_no,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "bank_no", $$v)
                                        },
                                        expression: "form.bank_no",
                                      },
                                    },
                                    _vm._l(
                                      _vm.accountList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label:
                                              item.settlement_bank +
                                              "-" +
                                              item.settlement_bank_account_num,
                                            value: item.bank_no,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c("br"),
                                  _vm.accountList.length === 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#71110e",
                                            "font-size": "12px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tips.not_bank_account")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.accountList.length === 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#3855f1",
                                            cursor: "pointer",
                                            "font-size": "12px",
                                            "padding-left": "10px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "changeComponent",
                                                { compName: "BankAccountList" }
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Go to Add")]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.form.withdraw_type === 2
                    ? [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "system.auto_withdraw_type"
                                      ),
                                      required: "",
                                      prop: "auto_withdraw_type",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "input-password",
                                        attrs: {
                                          clearable: "",
                                          disabled: _vm.posWithdrawConfigLocked,
                                        },
                                        on: { change: _vm.onChangeGroup },
                                        model: {
                                          value: _vm.form.auto_withdraw_type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "auto_withdraw_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.auto_withdraw_type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.autoWithdrawTypeMap,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.form.auto_withdraw_type === 1
                          ? _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "data.withdrawal_period"
                                          ),
                                          required: "",
                                          prop: "auto_withdraw_dates",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "input-password",
                                            attrs: {
                                              clearable: "",
                                              disabled:
                                                _vm.posWithdrawConfigLocked,
                                            },
                                            model: {
                                              value:
                                                _vm.form.auto_withdraw_dates,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "auto_withdraw_dates",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.auto_withdraw_dates",
                                            },
                                          },
                                          _vm._l(
                                            _vm.withdrawDayMap,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm.form.auto_withdraw_dates
                                          ? [
                                              _vm.language === "zh"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        color: "#AAB4C8",
                                                        "font-size": "14px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "提交后下一个提现日期为" +
                                                          _vm._s(
                                                            _vm.widthdrawalDate
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        color: "#AAB4C8",
                                                        "font-size": "14px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "The next cash-out date is " +
                                                          _vm._s(
                                                            _vm.widthdrawalDate
                                                          ) +
                                                          " after submission."
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.auto_withdraw_type === 2
                          ? _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "auto_withdraw_amount",
                                          rules: [
                                            {
                                              required: true,
                                              message: "Amount cannot be empty",
                                              trigger: "blur",
                                            },
                                            {
                                              validator: _vm.checkAmount,
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "label" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("data.fixed_amount")
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              { attrs: { placement: "top" } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "content" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "max-width": "300px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tips.fixed_amount_tip"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("svg-icon", {
                                                  staticStyle: {
                                                    width: "15px",
                                                    margin: "0",
                                                  },
                                                  attrs: {
                                                    "class-name":
                                                      "icon-function",
                                                    "icon-class":
                                                      "icon-blue-question",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                            _vm.isCurCountryID
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "data.cash_out_amount_should"
                                                          )
                                                        ) +
                                                        " ≥ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "toDivideWithDot"
                                                          )(
                                                            _vm.form
                                                              .withdraw_threshold
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c("el-input", {
                                          staticClass: "input-password",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Enter amount",
                                            autocomplete: "off",
                                            disabled:
                                              _vm.posWithdrawConfigLocked,
                                          },
                                          model: {
                                            value:
                                              _vm.form.auto_withdraw_amount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "auto_withdraw_amount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.auto_withdraw_amount",
                                          },
                                        }),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.$store.getters.isOpenMfa
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 16 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("system.mfa_verify_code"),
                                    prop: "verification_code",
                                    rules: [
                                      {
                                        validator: _vm.validateVerifyCode,
                                        trigger: ["blur", "change"],
                                      },
                                    ],
                                    required: "",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "input-password",
                                    attrs: {
                                      maxlength: "6",
                                      placeholder:
                                        "Enter your MFA verification code",
                                      autocomplete: "off",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.verification_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "verification_code",
                                          $$v
                                        )
                                      },
                                      expression: "form.verification_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-submit",
                      attrs: { type: "info", disabled: _vm.listLoading },
                      on: {
                        click: function ($event) {
                          return _vm.submitModify("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.submit")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }